import React, { useContext, useRef, useState } from 'react'
import { USER_CONTEXT } from '../context/ContextProvider'
import Dropdown from '../components/Dropdown'
import TaskSection from '../section/TaskSection'
import AddTaskCard from '../components/AddTaskCard'

const Home = () => {
  let { data, setData } = useContext(USER_CONTEXT)
  let currentGroupTasks = data.tasks.filter(
    (task) => task.group == data.selectedGroup,
  )

  return (
    <>
      {/* task header */}
      <div className="flex justify-between">
        <h4 className="text-3xl font-medium text-white">🔥 Task</h4>
        <Dropdown
          label="Groups"
          values={data.groups}
          selectedValue={data.selectedGroup}
          setSelectedValue={(i) =>
            setData({
              type: 'SELECT_GROUP',
              payload: { group: data.groups[i] },
            })
          }
        />
      </div>
      {/* task body */}
      <div className="mt-[34px] grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {currentGroupTasks.length > 0 ? (
          <>
            <TaskSection name={'Backlog'} id={'backlog'} />
            <TaskSection name={'To do'} id={'todo'} />
            <TaskSection name={'In Progress'} id={'inprogress'} />
            <TaskSection name={'Completed'} id={'completed'} />
          </>
        ) : (
          <div className='col-span-1 sm:col-span-2 lg:col-span-4 flex w-full justify-center mt-20'>
              <AddTaskCard/>
          </div>
        )}
      </div>
    </>
  )
}

export default Home
